module.exports = __webpack_public_path__ + "img/icon-qrcode.55c98088.svg";